var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9937 9.98047C23.9937 10.6836 23.3687 11.2344 22.6603 11.2344H21.3268L21.356 17.4922C21.356 17.5977 21.3476 17.7031 21.3351 17.8086V18.4375C21.3351 19.3008 20.5893 20 19.6683 20H19.0016C18.9558 20 18.9099 20 18.8641 19.9961C18.8058 20 18.7474 20 18.6891 20H17.3348H16.3347C15.4138 20 14.6679 19.3008 14.6679 18.4375V17.5V15C14.6679 14.3086 14.072 13.75 13.3345 13.75H10.6676C9.93001 13.75 9.33413 14.3086 9.33413 15V17.5V18.4375C9.33413 19.3008 8.58823 20 7.66732 20H6.66723H5.33795C5.27545 20 5.21294 19.9961 5.15044 19.9922C5.10043 19.9961 5.05043 20 5.00043 20H4.3337C3.41279 20 2.66689 19.3008 2.66689 18.4375V14.0625C2.66689 14.0273 2.66689 13.9883 2.67106 13.9531V11.2344H1.33345C0.583383 11.2344 0 10.6875 0 9.98047C0 9.62891 0.125011 9.31641 0.416702 9.04297L11.1009 0.3125C11.3926 0.0390625 11.726 0 12.0177 0C12.3094 0 12.6427 0.078125 12.8928 0.273438L23.5353 9.04297C23.8687 9.31641 24.0354 9.62891 23.9937 9.98047Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.ccb92d8f308be0726b638875ae8f483e.svg";
export { ForwardRef as ReactComponent };